import { ThreeRenderSpace } from "SATPROF_LIBRARY/DropinSupervisor/render-spaces/three-render-space";

import { PerspectiveCamera } from "three";
import UtilSP from "SATPROF_UTILS/UtilSP";
import TimingInfo from "SATPROF_LIBRARY/DropinSupervisor/timing-info";

import * as THREE from "three";
//import { OrbitControls } from "THREE_CONTROLS/OrbitControls.js";
//import OrbitalCameraHandler from "SATPROF_LIBRARY/DropinSupervisor/camera-handlers/orbit-camera-handler";
import UniversalCameraHandler from "SATPROF_LIBRARY/DropinSupervisor/camera-handlers/universal-camera-handler";

/**
 * @category Render Spaces
 *
 * @description This is a render space that is used to render a 3D scene.  It bootstraps additional utilities to the Three Render Space
 */
export class UniversalRenderSpace extends ThreeRenderSpace {
  public uniPerspectiveCamera: PerspectiveCamera;
  public myscene: THREE.Scene;
  ///public myrenderer:any;
  public uniCamHandler: UniversalCameraHandler;
  private _backgroundColor: string = "black";
  private _transparentBackground: boolean = false;
  private _hideAll: boolean = false;
  public directionalLight1: THREE.DirectionalLight;
  public ambientLight1: THREE.AmbientLight;

  constructor(canvas?: HTMLCanvasElement, rendererParams: THREE.WebGLRendererParameters = {}) {
    super(canvas, rendererParams);
  }

  // perform our setup
  onFrameZero() {
    this.uniPerspectiveCamera = <PerspectiveCamera>this.getCamera();
    this.myscene = this.getScene();

    ///this.myrenderer = this.getRenderer();
    //const scene = this.getScene();
    //const camera = this.getCamera();

    const color = 0xffffff;
    const intensity = 1;
    this.directionalLight1 = new THREE.DirectionalLight(color, intensity);
    this.directionalLight1.position.set(-1, 2, 4);
    this.myscene.add(this.directionalLight1);

    this.ambientLight1 = new THREE.AmbientLight(0xa0a0a0); // soft white light
    this.myscene.add(this.ambientLight1);

    this.transparentBackground = false;
    this.backgroundColor = "black";

    //this.myscene.background = new THREE.Color( 0xFF0000, 0);//UtilSP.c2rgba("red",0));
    //this.renderer.setClearAlpha(0);
    //this.renderer.setClearColor(0xFF0000, 0);

    //console.log("In timeline: degrees = "+UtilSP.degrees(Math.PI/2));
    //-----------------------------------------
    this.uniCamHandler = new UniversalCameraHandler();
    this.registerCameraHandler(this.uniCamHandler);
  }

  public onRequestAnimFrame(timingInfo: TimingInfo) {
    //console.log('in onRequestAnimFrame');
    this.uniCamHandler.doEveryFrame();
    this.doRender(); // in three-render-space
    //this.renderer.render( this.scene, this.uniPerspectiveCamera );
  }
  public set backgroundColor(val: string) {
    this._backgroundColor = val;
    this.renderer.setClearColor(UtilSP.c2rgba(this._backgroundColor), 1);
  }
  public get backgroundColor() {
    return this._backgroundColor;
  }
  public set transparentBackground(val: boolean) {
    // NOTE: alpha must be set to true when the renderer was instantiated!
    this._transparentBackground = val;
    if (this._transparentBackground) {
      this.renderer.setClearColor(0x000000, 0);
    } else {
      this.renderer.setClearColor(UtilSP.c2rgba(this._backgroundColor), 1);
    }
  }
  public get transparentBackground() {
    return this._transparentBackground;
  }
  public set hideAll(val: boolean) {
    this._hideAll = val;
    if (this._hideAll) {
      this.renderer.setClearColor(0x000000, 0); // transparent
      this.myscene.visible = false;
    } else {
      this.myscene.visible = true;
      this.renderer.setClearColor(UtilSP.c2rgba(this._backgroundColor), 1);
    }
  }
  public get hideAll() {
    return this._hideAll;
  }
}

UniversalRenderSpace["Version"] = "1.0.0";

export default UniversalRenderSpace;
